<mat-card>
    <mat-card-title>Process Server Side/Client Side</mat-card-title>
    <mat-card-content>
        Server side lookup will auto-populate mapped fields on first state transition (record save)
    </mat-card-content>
    <mat-card-content>
        <mat-radio-group [(ngModel)]="processType" (change)="processingTypeChange()">
            <mat-radio-button value="client">Client Side</mat-radio-button>
            <mat-radio-button value="server">Server Side</mat-radio-button>
        </mat-radio-group>

    </mat-card-content>
</mat-card>